import React, { useState, useEffect } from 'react';
import './ClientsCarousel.scss';

const ClientsCarousel: React.FC = () => {
  // Array de logos de clientes (placeholder - substitua pelos logos reais)
  const clients = [
    { name: 'Wellvet', logo: '/customers/wellvet.png' },
    { name: 'Togalt Group', logo: '/customers/togalt.webp' },
    { name: 'Entelmatica', logo: '/customers/entelmatica.avif' },
    { name: 'Ecopilots', logo: '/customers/ecopilots.png' },
    { name: 'SOS Bombas e máquinas', logo: '/customers/sos-bombas.png' },
    { name: 'TR Tron', logo: '/customers/tr-tron.png' },
    { name: 'Zora Bar', logo: '/customers/zora.png' },
  ];

  const [loadedImages, setLoadedImages] = useState<Set<number>>(new Set());
  const [visibleCount, setVisibleCount] = useState(2); // Começa carregando apenas 2 imagens

  // Carrega imagens progressivamente para evitar rate limit
  useEffect(() => {
    if (visibleCount < clients.length) {
      const timer = setTimeout(() => {
        setVisibleCount(prev => Math.min(prev + 2, clients.length));
      }, 300); // Delay de 300ms entre cada lote de 2 imagens

      return () => clearTimeout(timer);
    }
  }, [visibleCount, clients.length]);

  const handleImageLoad = (index: number) => {
    setLoadedImages(prev => new Set(prev).add(index));
  };

  const handleImageError = (index: number, event: React.SyntheticEvent<HTMLImageElement>) => {
    console.warn(`Falha ao carregar imagem: ${clients[index].name}`);
    // Tenta recarregar após 1 segundo
    setTimeout(() => {
      const img = event.currentTarget;
      if (img.src) {
        img.src = img.src.split('?')[0] + '?retry=' + Date.now();
      }
    }, 1000);
  };

  return (
    <section className="clients-carousel">
      <div className="clients-container">
        <h3 className="clients-title">Empresas que confiam no 77Gestão</h3>
        <div className="carousel-wrapper">
          <div className="carousel-track">
            {/* Primeira sequência de logos */}
            {clients.map((client, index) => (
              <div 
                key={`client-${index}`} 
                className={`client-item ${loadedImages.has(index) ? 'loaded' : ''}`}
              >
                {index < visibleCount ? (
                  <img 
                    src={client.logo} 
                    alt={client.name}
                    loading="lazy"
                    onLoad={() => handleImageLoad(index)}
                    onError={(e) => handleImageError(index, e)}
                  />
                ) : (
                  <div className="client-placeholder" />
                )}
              </div>
            ))}
            {/* Duplicar para animação infinita - só renderiza depois que todas carregarem */}
            {visibleCount >= clients.length && clients.map((client, index) => (
              <div 
                key={`client-duplicate-${index}`} 
                className="client-item loaded"
              >
                <img 
                  src={client.logo} 
                  alt={client.name}
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientsCarousel;
